module.exports = __webpack_public_path__ + "img/select-bg-S.c73cce62.png";